import { render, staticRenderFns } from "./suspensionModel.vue?vue&type=template&id=d77281da"
import script from "./suspensionModel.vue?vue&type=script&lang=js"
export * from "./suspensionModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d77281da')) {
      api.createRecord('d77281da', component.options)
    } else {
      api.reload('d77281da', component.options)
    }
    module.hot.accept("./suspensionModel.vue?vue&type=template&id=d77281da", function () {
      api.rerender('d77281da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contract/customerManage/suspensionModel.vue"
export default component.exports